import { defineComponent, ref, PropType, nextTick } from 'vue';
import { DOMAIN_ENV_ENUM, DOMAIN_SYSTEM_ENUM } from '@myna/utils';
import { ElMessage } from 'element-plus';
import { createDomainConfig, updateDomainConfig } from '@/api/system-config';
import { IUpdateDomainConfig } from '@/api/system-config/type.d';

const URL_REG = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/;

export default defineComponent({
  emits: ['update:visible', 'refresh'],
  props: {
    form: {
      type: Object,
      default: () => ({} as PropType<IUpdateDomainConfig>),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const ruleForm = ref<any | null>(null);
    const formData = ref<IUpdateDomainConfig>({
      id: '',
      domainSystem: '',
      domainBaseUrl: '',
      domainDesc: '',
      domainEnv: '',
    });

    const handleOpenDialog = async () => {
      try {
        await nextTick();
        (ruleForm.value as any).resetFields();
        formData.value.id = props.form?.id || '';
        formData.value.domainSystem = props.form?.domainSystem || '';
        formData.value.domainBaseUrl = props.form?.domainBaseUrl || '';
        formData.value.domainDesc = props.form?.domainDesc || '';
        formData.value.domainEnv = props.form?.domainEnv || '';
      } catch (e) {
        console.log(e);
      }
    };
    const handleClose = () => {
      emit('update:visible', false);
    };
    const handleSubmit = async () => {
      try {
        const valid = await ruleForm.value!.validate();
        if (valid) {
          await (formData.value.id
            ? updateDomainConfig({
              ...formData.value,
            } as any)
            : createDomainConfig({
              ...formData.value,
            } as any));
          ElMessage.success('操作成功');
          emit('refresh');
          emit('update:visible');
        }
      } catch (e) {
        console.log('保存失败', e);
      }
    };
    return {
      handleOpenDialog,
      handleClose,
      ruleForm,
      DOMAIN_ENV_ENUM,
      DOMAIN_SYSTEM_ENUM,
      formData,
      rules: {
        domainSystem: [{ required: true, message: '请选择域名所属系统', trigger: 'change' }],
        domainBaseUrl: [
          {
            required: true,
            trigger: 'blur',
            validator(rule: any, value: any, callback: any) {
              if (!value) {
                callback(new Error('请输入域名地址'));
              } else if (!URL_REG.test(value)) {
                callback(new Error('域名地址有误'));
              } else {
                callback();
              }
            },
          },
        ],
        domainEnv: [{ required: true, message: '请选择环境', trigger: 'blur' }],
      },
      handleSubmit,
    };
  },
  render() {
    return (
      <el-dialog
        title={this.formData.id ? '编辑环境域名配置' : '添加环境域名配置'}
        modelValue={this.visible}
        close-on-click-modal={false}
        onClose={this.handleClose}
        onOpen={this.handleOpenDialog}
        v-slots={{
          footer: () => (
            <div>
              <el-button onClick={this.handleClose} size="default">
                取 消
              </el-button>
              <el-button type="primary" size="default" onClick={this.handleSubmit}>
                确 定
              </el-button>
            </div>
          ),
        }}
      >
        <el-form
          label-width="110px"
          rules={this.rules}
          model={this.formData}
          size="default"
          ref="ruleForm"
        >
          <el-form-item label="域名所属系统" prop="domainSystem">
            <el-input
              v-model={[this.formData.domainSystem, ['trim']]}
              placeholder="请输入域名所属系统"
            />
          </el-form-item>
          <el-form-item label="域名地址" prop="domainBaseUrl">
            <el-input
              v-model={[this.formData.domainBaseUrl, ['trim']]}
              placeholder="请输入域名地址"
            />
          </el-form-item>
          <el-form-item label="环境" prop="domainEnv">
            <el-input v-model={[this.formData.domainEnv, ['trim']]} placeholder="请输入环境" />
          </el-form-item>
          <el-form-item label="域名名称描述">
            <el-input
              type="textarea"
              v-model={[this.formData.domainDesc, ['trim']]}
              placeholder="请输入域名名称描述"
            />
          </el-form-item>
        </el-form>
      </el-dialog>
    );
  },
});
